import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";

interface WizardActionBarProps {
  onBack?: () => void;
  backLabel?: string;
  primaryLabel: ReactNode;
  onPrimary: () => void;
  isPrimaryLoading?: boolean;
  secondaryLabel?: ReactNode;
  onSecondary?: () => void;
  isSecondaryLoading?: boolean;
}

/**
 * docs/ui/layouts.md's `WizardLayout` "Fixed bottom action bar" slot:
 * Back/Continue on steps 1–2, Publish/Save Draft on the final step — one
 * component covering both shapes via optional props, since the visual
 * treatment (fixed, full-width, border-top) never changes between them.
 */
export function WizardActionBar({
  onBack,
  backLabel = "Back",
  primaryLabel,
  onPrimary,
  isPrimaryLoading = false,
  secondaryLabel,
  onSecondary,
  isSecondaryLoading = false,
}: WizardActionBarProps) {
  return (
    <div className="sticky bottom-0 -mx-4 mt-8 flex items-center justify-between gap-3 border-t border-border bg-background/95 px-4 py-4 backdrop-blur sm:mx-0 sm:rounded-b-lg">
      {onBack ? (
        <Button type="button" variant="outline" onClick={onBack}>
          {backLabel}
        </Button>
      ) : (
        <span />
      )}
      <div className="flex items-center gap-3">
        {secondaryLabel && onSecondary && (
          <Button
            type="button"
            variant="outline"
            onClick={onSecondary}
            isLoading={isSecondaryLoading}
          >
            {secondaryLabel}
          </Button>
        )}
        <Button type="button" onClick={onPrimary} isLoading={isPrimaryLoading}>
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
}
